@let displayFiles = (displayFiles$ | async) ?? [];

<ul #listElementRef>
  @for (file of displayFiles; track file) {
    <li class="p-0 m-0">
      <a
        #element
        [href]="useExternalClickAction ? '' : getFileUrlHref(file.url, isSecure)"
        (click)="
          useExternalClickAction
            ? externalClickAction($event, file, element)
            : downloadFile($event, file.url)
        "
        download
        class="file-table-el"
        target="_blank"
        rel="noopener noreferrer"
      >
        @if (file.thumbnail) {
          <img [src]="file.thumbnail" [alt]="file.type" />
        }
        <span class="truncate">{{ file.filename }}</span>
      </a>
    </li>
  }
</ul>

<div class="actions">
  @if ((actionsAlwaysVisible && files.length) || files.length > displayFiles.length) {
    <a class="more-button" [class.!flex]="actionsAlwaysVisible">
      <button
        blazeIconButton="bat"
        class="bat-action-button"
        [blazeIconButtonActive]="isMenuOpen"
        #menuTrigger
        [matMenuTriggerFor]="menu"
      >
        <mat-icon svgIcon="icon_more_h_24" />
      </button>
    </a>
  }
  @if (canAddValue) {
    <a
      class="add-button"
      [class.!flex]="actionsAlwaysVisible"
      (click)="externalClickAction($event, undefined, undefined, true)"
    >
      <button blazeIconButton="bat" class="bat-action-button">
        <mat-icon svgIcon="icon_add_32" />
      </button>
      <span>Click to add new file</span>
    </a>
  }
</div>

<a
  #placeholderTag
  download
  class="file-table-el placeholder"
  target="_blank"
  rel="noopener noreferrer"
>
  <img src="assets/images/file-png.svg" alt="png" />
  <span class="truncate">&nbsp;</span>
</a>

<mat-menu #menu class="bd-menu file-menu">
  <ng-template matMenuContent>
    @for (file of files; track file) {
      <ng-container
        [ngTemplateOutlet]="dropdownFilesListTpl"
        [ngTemplateOutletContext]="{ $implicit: file }"
      />
    }
  </ng-template>
</mat-menu>

<ng-template #dropdownFilesListTpl let-file>
  <div
    #element
    class="file-option"
    [ngStyle]="{ backgroundColor: cellStyles?.cellBackground }"
    (mouseover)="element.style.backgroundColor = cellStyles?.cellHoverBackground || ''"
    (mouseout)="element.style.backgroundColor = cellStyles?.cellBackground || ''"
  >
    <div class="file-table-el" [ngStyle]="{ color: cellStyles?.cellColor }" #element>
      @if (file.thumbnail) {
        <img [src]="file.thumbnail" [alt]="file.type" />
      }
      <span class="truncate">{{ file.filename }}</span>
    </div>
    <div class="file-actions">
      <a
        class="h-16"
        [href]="getFileUrlHref(file.url, isSecure)"
        download
        target="_blank"
        (click)="downloadFile($event, file.url)"
        rel="noopener noreferrer"
      >
        <mat-icon class="download" svgIcon="download" />
      </a>
      @if (useExternalClickAction) {
        <mat-icon
          class="delete"
          (click)="deleteFileFromList($event, file, element)"
          svgIcon="icon_trash_16"
        />
      }
    </div>
  </div>
</ng-template>
